import React from "react";
import Menu from "./components/Menu";
import "swagger-ui-dist/swagger-ui.css";
import "./style.scss";
import Introduction from "./components/Introduction";
import Swagger from "./Swagger";
import auth from "./apis/Auth.json";
import users from "./apis/Users.json";
import groups from "./apis/Groups.json";
import events from "./apis/Events.json";
import punchings from "./apis/Punchings.json";
import contacts from "./apis/Contacts.json";
import wiki from "./apis/Wiki.json";
import fax from "./apis/Fax.json";
import mailoffice from "./apis/Mailoffice.json";
import tickets from "./apis/Tickets.json";

class App extends React.Component {
  state = {
    selected: "intro",
  };

  render() {
    const getSpec = () => {
      switch (this.state.selected) {
        case "wiki":
          return wiki;
        case "tickets":
          return tickets;
        case "fax":
          return fax;
        case "mailoffice":
          return mailoffice;
        case "punchings":
          return punchings;
        case "contacts":
          return contacts;
        case "events":
          return events;
        case "groups":
          return groups;
        case "users":
          return users;
          case "auth":
        default:
          return auth;
      }
    };

    return (
      <div className="container-fluid">
        <div className="row" style={{ minHeight: "100vh" }}>
          <nav className="col-3 px-0" style={{ background: "#0098e5" }}>
            <Menu
              selected={this.state.selected}
              onClick={(section) => this.setState({ selected: section })}
            />
          </nav>

          <main role="main" className="col px-4">
            {this.state.selected === "intro" ? (
              <Introduction />
            ) : /*this.state.selected === "auth" ? (
              <Auth />
            ) :*/ (
              <Swagger spec={getSpec()} />
            )}
          </main>
        </div>
      </div>
    );
  }
}
export default App;
